import React, { useEffect, useState, useMemo } from 'react';

import Loader from '../../../elements/Loader';
import Table from '../../../elements/Table';
import ViewButton from '../../../elements/ViewButton';
import axios from '../../../services/MyAxios';

import { CRM_PERMISSION } from '../Helpers/CrmPermissions';

import { CASINO_GAME_CREATORS_SEO_SHOW, CASINO_GAME_CREATORS_SHOW } from '../Helpers/CrmUrls';
import { replaceUrlParams } from '../Helpers/UrlHelper';

function GameCreatorsList() {
    const [isLoading, setIsLoading] = useState(true);
    const [gameCreators, setGameCreators] = useState([]);

    const apiUrl = '/crea/casino/api/game-creators';

    function getGameCreators() {
        setIsLoading(true);
        axios.get(apiUrl).then((response) => {
            setGameCreators(response.data);
        });
        setIsLoading(false);
    }

    useEffect(() => {
        getGameCreators();
    }, []);

    const columns = useMemo(
        () => [
            {
                Header: 'Name',
                accessor: 'name',
            },
            {
                Header: 'Games count',
                accessor: 'casino_games_count',
            },
            {
                Header: 'Actions',
                accessor: 'id',
                Cell: ({ value }) => (
                    <div>
                        <ViewButton
                            url={replaceUrlParams(CASINO_GAME_CREATORS_SHOW, { id: value })}
                            permissions={[CRM_PERMISSION.GAME_CREATORS_SHOW]}
                            key="view"
                        />
                        <ViewButton
                            url={replaceUrlParams(CASINO_GAME_CREATORS_SEO_SHOW, { id: value })}
                            permissions={[CRM_PERMISSION.INDEX_CASINO_GAME_CREATOR_SEO]}
                            key="edit-seo"
                        />
                    </div>
                ),
            },
        ],
        []
    );

    return (
        <div className="card">
            <div className="card-header d-flex justify-content-between">
                <span>All game creators</span>
            </div>
            <div className="card-body">
                {gameCreators.length > 0 ? (
                    <Loader loading={isLoading} content={() => <Table columns={columns} data={gameCreators} />} />
                ) : (
                    <p>Cannot find any game creator.</p>
                )}
            </div>
        </div>
    );
}

export default GameCreatorsList;
